import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'doc-format-xls-file-icon',
  templateUrl: './doc-format-xls-file-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class DocFormatXlsFileIconComponent {}
